import React from 'react'
import Icon from './IconBase'

const Folder = props => (
  <Icon viewBox="0 0 21 17" {...props}>
<path d="M17.6684 14.2697H18.1684V13.7697V3.96053V3.46053H17.6684H1.93249H1.43249V3.96053V13.7697V14.2697H1.93249H17.6684ZM9.44675 2.33366L9.59323 2.48026H9.80046H17.6684C18.4351 2.48026 19.1009 3.1617 19.1009 3.96053V13.7697C19.1009 14.5686 18.4351 15.25 17.6684 15.25H1.93249C1.16586 15.25 0.5 14.5686 0.5 13.7697V1.98026C0.5 1.18144 1.16586 0.5 1.93249 0.5H7.61473L9.44675 2.33366Z" transform="translate(0.490234 0.75)" />
  </Icon>
)

export default Folder